import { render, staticRenderFns } from "./SplittedLayout.vue?vue&type=template&id=474df88d&scoped=true&"
import script from "./SplittedLayout.vue?vue&type=script&lang=js&"
export * from "./SplittedLayout.vue?vue&type=script&lang=js&"
import style0 from "./SplittedLayout.vue?vue&type=style&index=0&id=474df88d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474df88d",
  null
  
)

export default component.exports